<style>
.xlTextfield {
    font-size: 44px;
}

.xlTextfield input {
    font-size: 44px;
}
</style>

<template>
    <div>
      <v-list two-line>
        <v-list-item-group active-class="pink--text">
          <template >
              <div v-for="(meterRead, index) in meterReads" :key="meterRead.meterId">
                <v-list-item >
                  <template>
                    <v-list-item-content>
                      <v-row>
                        <v-col cols="8">
                          <v-list-item-title class="font-weight-bold">{{meterRead.location}}</v-list-item-title>
                          <v-row>
                            <v-col cols="10">
                              <v-list-item-subtitle class="text--primary">{{ meterRead.meterCode }}</v-list-item-subtitle>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="1">
                          <v-icon color="green" v-if="meterRead.status === 'SYNCED'" class="py-1">mdi-sync</v-icon>
                          <v-icon color="red" v-if="meterRead.status === 'PENDING'" class="py-1">mdi-sync-alert</v-icon>
                        </v-col>
                        <v-col cols="3">
                          <v-list-item-subtitle class="text--primary text-h6 text-right text-center py-1">
                            {{ meterRead.meterRead }}
                          </v-list-item-subtitle>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
    
                    <v-list-item-action @click="gotoMeterRead(meterRead)">
                      <v-icon color="grey lighten-1">
                        mdi-pencil-plus
                      </v-icon>
    
                    </v-list-item-action>
                  </template>
                </v-list-item>
    
                <v-divider v-if="index < meterReads.length - 1"
                           :key="index"></v-divider>
              </div>
          </template>
        </v-list-item-group>
      </v-list>
    </div>
</template>

<script>

export default {
    name: "MetersList",
    props: {
        meterReads: Array
    },
    data() {
        return {
            isLoading: false,
            searchInput: ''
        }
    },
    async mounted() {
    },
    computed: {
    },
    watch: {
    },
    methods: {
        gotoMeterRead(meterRead) {
            this.$emit('gotoMeterRead', meterRead);
        },  
    }
}
</script>

<style scoped>
</style>